const heightMenuMobile = () => {
    const menuMobile = document.querySelector('#menu-mobile');

    if ( menuMobile ){

        if (window.matchMedia("(max-width: 991px)").matches) {
        const header = document.getElementById('header');
        menuMobile.style.top = header.offsetHeight + 'px';
        menuMobile.style.height = window.innerHeight - header.offsetHeight + 'px';
        }else{
            menuMobile.removeAttribute('style')
        }
    }
 

}

export default heightMenuMobile;